/* ==========================================================================
   EMIR CHAÎNE — synchronisation panier (chargé sur toutes les pages)

   Une chaîne compagnon est une ligne de panier portant la propriété cachée
   _emir_chaine_pour = <clé>. Son pendentif porte _emir_bundle = <clé>.
   Après tout changement du panier (ajout, suppression, quantité, vidage,
   que ce soit par le thème, le tiroir Vanga ou la page panier) :
     - si le pendentif n'est plus là  -> la chaîne est retirée
     - si la quantité diffère          -> la chaîne suit la quantité du pendentif
   Gère aussi la chaîne « en attente » posée par emir-perso.js quand la fiche
   a dû être soumise en POST natif (fichier joint).

   Garde-fous (mesurés le 2026-09-11 avec le tiroir Vanga) :
   - nos propres appels passent par le fetch d'origine : jamais re-détectés ;
   - pendant une synchronisation, les changements tiers sont ignorés mais
     notés (« again ») et rejoués UNE fois à la fin ;
   - au plus 6 synchronisations par fenêtre de 10 s (soupape anti-boucle) ;
   - les clés de ligne sont relues à chaque passe (Vanga réécrit les lignes).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__emirChaineCart) return;
  window.__emirChaineCart = true;

  var RX = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  var timer = null;
  var syncing = false;
  var again = false;
  var stamps = [];

  function api(url, opts) { return (origFetch || window.fetch)(url, opts); }
  function onCartPage() { return /^\/cart\/?$/.test(window.location.pathname); }

  function refreshDrawer() {
    if (window.Vanga && typeof window.Vanga.refresh === 'function') {
      try { window.Vanga.refresh(); } catch (e) {}
    }
  }

  function allowed() {
    var now = Date.now();
    stamps = stamps.filter(function (t) { return now - t < 10000; });
    if (stamps.length >= 6) return false;
    stamps.push(now);
    return true;
  }

  function schedule() {
    if (syncing) { again = true; return; }
    clearTimeout(timer);
    timer = setTimeout(sync, 500);
  }

  function done() {
    syncing = false;
    if (again) { again = false; setTimeout(sync, 800); }
  }

  function sync() {
    if (syncing) { again = true; return; }
    if (!allowed()) return;
    syncing = true;
    api('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var parents = {};
        var updates = {};
        var n = 0;
        (cart.items || []).forEach(function (it) {
          var k = it.properties && it.properties._emir_bundle;
          if (k) parents[k] = (parents[k] || 0) + it.quantity;
        });
        (cart.items || []).forEach(function (it) {
          var k = it.properties && it.properties._emir_chaine_pour;
          if (!k) return;
          var want = parents[k] || 0;
          if (it.quantity !== want) { updates[it.key] = want; n++; }
        });
        if (!n) return null;
        return api('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          if (onCartPage()) { window.location.reload(); return; }
          refreshDrawer();
        });
      })
      .then(done, done);
  }

  /* ---- Détection des changements du panier : fetch + XMLHttpRequest ---- */
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = '';
      try { url = typeof input === 'string' ? input : (input && input.url) || ''; } catch (e) {}
      var p = origFetch(input, init);
      if (url && RX.test(url)) {
        p.then(function () { schedule(); }, function () {});
      }
      return p;
    };
  }
  if (window.XMLHttpRequest) {
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      try { this.__emirUrl = String(url); } catch (e) {}
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__emirUrl && RX.test(this.__emirUrl)) {
        this.addEventListener('loadend', function () { schedule(); });
      }
      return origSend.apply(this, arguments);
    };
  }

  /* ---- Chaîne en attente (fiche soumise en POST natif à cause d'un fichier) ---- */
  function addPending() {
    var raw = null;
    try { raw = window.sessionStorage.getItem('emir_pending_chain'); } catch (e) {}
    if (!raw) return;
    try { window.sessionStorage.removeItem('emir_pending_chain'); } catch (e) {}
    var p = null;
    try { p = JSON.parse(raw); } catch (e) { return; }
    if (!p || !p.id || !p.key) return;
    api('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: p.id, quantity: p.qty || 1, properties: { _emir_chaine_pour: p.key, 'Pour': p.title || '' } }] })
    }).then(function () {
      if (onCartPage()) { window.location.reload(); return; }
      schedule();
    }).catch(function () {});
  }

  function boot() { addPending(); schedule(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
